// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingCustomerResponse

export type WidgetBookingCustomerApiResponse = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	customFields: Record<string, string>;
};

export type WidgetBookingCustomer = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	customFields: Record<string, string>;
};

export function hydrateWidgetBookingCustomer(data: WidgetBookingCustomerApiResponse): WidgetBookingCustomer {
	return {
		...data,
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
	};
}